import { useCallback } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

export const useLargeCardNavigate = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const doRedirectBack = useCallback(() => {
    navigate(location?.state?.isRedirectAfterCreated ? -2 : -1);
  }, [navigate, location]);

  return {
    doRedirectBack,
    navigate,
    location,
  };
};
